// extracted by mini-css-extract-plugin
export var animationFadeUp = "style-module--animationFadeUp--32192";
export var header = "style-module--header--e4ad6";
export var header__image = "style-module--header__image--54b1d";
export var header__postDate = "style-module--header__post-date--2563b";
export var header__subTitle = "style-module--header__sub-title--f89f2";
export var header__title = "style-module--header__title--68595";